/**
 * Emoji icon for a sport name (team badges, invitation cards, …).
 * Matching is case-insensitive and tolerant of variants ("Beach Volleyball",
 * "Table Tennis", "Soccer"). Unknown sports get a neutral trophy.
 */

// Order matters: more specific names first ("table tennis" before "tennis",
// "american football" before "football").
const SPORT_ICON_RULES = [
  ["american football", "🏈"],
  ["table tennis", "🏓"],
  ["ping pong", "🏓"],
  ["beach volleyball", "🏐"],
  ["volleyball", "🏐"],
  ["basketball", "🏀"],
  ["badminton", "🏸"],
  ["pickleball", "🏓"],
  ["squash", "🎾"],
  ["tennis", "🎾"],
  ["ice hockey", "🏒"],
  ["field hockey", "🏑"],
  ["hockey", "🏑"],
  ["baseball", "⚾"],
  ["softball", "🥎"],
  ["cricket", "🏏"],
  ["rugby", "🏉"],
  ["handball", "🤾"],
  ["soccer", "⚽"],
  ["futsal", "⚽"],
  ["football", "⚽"],
  ["golf", "⛳"],
  ["swimming", "🏊"],
  ["athletics", "🏃"],
  ["running", "🏃"],
  ["cycling", "🚴"],
  ["boxing", "🥊"],
  ["ultimate", "🥏"],
  ["frisbee", "🥏"],
];

export const DEFAULT_SPORT_ICON = "🏆";

export function getSportEmoji(sportName) {
  const name = String(sportName || "").toLowerCase().trim();
  if (!name) return DEFAULT_SPORT_ICON;
  const rule = SPORT_ICON_RULES.find(([key]) => name.includes(key));
  return rule ? rule[1] : DEFAULT_SPORT_ICON;
}

export default getSportEmoji;
